import { createSelector } from 'reselect';

const selectPhotos = state => state.photo.photos;
export const selectPhotoPhotos = createSelector(
  [selectPhotos],
  (photos) => photos
);